export default __webpack_public_path__ + "86fa77ef55778f5634b477288a72fe68.svg";